// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/play-cta-outline.svg';

export const PlayCtaOutline = (props: SvgIconProps) => {
    return <SvgIcon component={Svg} inheritViewBox {...props} />;
};
